export default "__VITE_ASSET__Cz7jXdh4__"